import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=1ceb8447&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "../monthly-report/add.css?vue&type=style&index=0&id=1ceb8447&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceb8447",
  null
  
)

export default component.exports